<div class="hwscan-header">
	<div class="row">
		<div [ngSwitch]="headerType">
			<div id="rbs-header-height-filler" *ngSwitchCase="enumScanHeaderTypeFinished.RecoverBadSectors" aria-live="polite">
				<h2 id="hwscan-rbs-finished-title" aria-live="polite" role="heading" class="col title">{{ 'hardwareScan.result' | translate }}: {{ 'hardwareScan.' + recoverResult.toLowerCase() | translate }}</h2>
			</div>
			<div *ngSwitchCase="enumScanHeaderTypeFinished.Scan">
				<ng-container *ngTemplateOutlet="scanFinishedHeaderTitle"></ng-container>

				<div class="description-row">
					<ng-container
						[ngTemplateOutlet]="scanFinishedFinalResultCode"
						[ngTemplateOutletContext]="{ finalResultCodeTitle: 'hardwareScan.scanFinishedHeader.finalResultCodeLabel' | translate, finalResultCodeValue: 'hardwareScan.' + getFinalResultCode().toLowerCase() | translateDefault: getFinalResultCode() }">
					</ng-container>
				</div>

				<div class="description-row" *ngIf="numberTestsFailed > 0">
					<span id="hwscan-failure-description" role="text" class="row failure-description"> {{ 'hardwareScan.scanFinishedHeader.frcFailureDescription' | translate }}</span>
					<span id="hwscan-support-instruction" role="text" class="row failure-description"> {{ 'hardwareScan.scanFinishedHeader.lenovoSupportInstruction' | translate }}</span>
				</div>

				<div class="button-row">
					<div class="row" *ngIf="numberTestsFailed > 0; else successfulScan">
						<vtr-material-button
							linkId="hwscan-support-btn"
							[label]="'hardwareScan.scanFinishedHeader.supportButtonText' | translate | uppercase"
							[tooltipText] ="'hardwareScan.scanFinishedHeader.supportButtonText' | translate"
							(buttonClick)="onClickSupport(contactusUrl)"
							heightSize="lg">
						</vtr-material-button>
						<vtr-ui-hyperlink-button
							hyperlinkStyle="xs-white"
							linkId="hwscan-scan-again-btn"
							linkRole="button"
							[upperCaseLabel]="true"
							[label]="'hardwareScan.scanFinishedHeader.scanAgainButtonText' | translate"
							[tooltipText]="'hardwareScan.reminderTimeRetrieveHardwareInformation' | translate"
							(hyperlinkClick)="onScanAgain()">
						</vtr-ui-hyperlink-button>
					</div>

					<ng-template #successfulScan>
						<div class="row" *ngIf="numberTestsFailed === 0">
							<div class="row">
								<vtr-material-button
									linkId="hwscan-scan-again-btn"
									[label]="'hardwareScan.scanFinishedHeader.scanAgainButtonText' | translate | uppercase"
									[tooltipText] ="'hardwareScan.scanFinishedHeader.scanAgainButtonText' | translate"
									(buttonClick)="onScanAgain()"
									heightSize="lg">
								</vtr-material-button>
							</div>
						</div>
					</ng-template>
				</div>
			</div>
			<div *ngSwitchCase="enumScanHeaderTypeFinished.ViewResults">

				<!-- Defines a title -->
				<ng-container *ngTemplateOutlet="scanFinishedHeaderTitle"></ng-container>

				<!-- Show the date and result about the last scan -->
				<p class="result-date-description">
					<span id="hwscan-previous-results-last-scan-text" role="text">{{ 'hardwareScan.lastScanOn' | translate }} </span>
					<span id="hwscan-previous-results-last-scan-value" role="text">{{ lastScanResultCompletionInfo.date | formatLocaleDateTime }}</span>
				</p>

				<!-- Show the result code -->
				<ng-container
					[ngTemplateOutlet]="scanFinishedFinalResultCode"
					[ngTemplateOutletContext]="{ finalResultCodeTitle: 'hardwareScan.finalResultCode' | translate, finalResultCodeValue: getLastFinalResultCode() }">
				</ng-container>

				<!-- Defines a message about lenovo support -->
				<div class="description-row" *ngIf="numberTestsFailed > 0">
					<p id="hwscan-failure-description" role="text" class="row failure-description"> {{ 'hardwareScan.scanFinishedHeader.frcFailureDescription' | translate }}</p>
					<p id="hwscan-support-instruction" role="text" class="row failure-description"> {{ 'hardwareScan.scanFinishedHeader.lenovoSupportInstruction' | translate }}</p>
				</div>

				<div class="button-row" *ngIf="numberTestsFailed > 0">
					<div class="row">
						<vtr-material-button
							linkId="hwscan-support-btn"
							[label]="'hardwareScan.scanFinishedHeader.supportButtonText' | translate | uppercase"
							[tooltipText] ="'hardwareScan.scanFinishedHeader.supportButtonText' | translate"
							(buttonClick)="onClickSupport(contactusUrl)"
							heightSize="lg">
						</vtr-material-button>
					</div>
				</div>
			</div>
		</div>
	</div>

	<mat-menu #tooltipFinalResultCode [hasBackdrop]="false" class="vtr-tooltip question-mark-tooltip" xPosition="before" yPosition="center">
		<div mat-menu-item>
			<div aria-live="polite"
				id="hwscan-final-result-code-success-tooltip" role="text"
				[innerHTML]="'hardwareScan.scanFinishedHeader.frcSuccessDescription' | translate">
			</div>
		</div>
		<!-- This button is being called as hyperlink instead of global component because of a problem with NVDA read -->
		<div class="hyperlink-box">
			<button
				mat-menu-item
				class="hyperlink-outline"
				linkId="hwscan-final-result-code-support-link"
				[tabIndex]="1"
				(click)="openContactusPage()"
				[attr.role]="'menuitem'">
					<div class="hyperlink-text-container">
						<span
							class="hyperlink xs-300-lightGray1"
							[innerHTML]="'hardwareScan.scanFinishedHeader.supportButtonText' | translate">
						</span>
					</div>
			</button>
		</div>
	</mat-menu>

	<!-- Common templates used in both Scan and Previous Results headers -->
	<ng-template #scanFinishedHeaderTitle>
		<div class="col">
			<h2 *ngIf="numberTestsFailed === 0; else hasFailedTestHeaderTitle" id="hwscan-title-success" aria-live="polite" role="heading" class="title">{{ 'hardwareScan.result' | translate }}: {{ 'hardwareScan.' + scanResult.toLowerCase() | translate }}</h2> <!-- No failures -->
			<ng-template #hasFailedTestHeaderTitle>
				<h2 id="hwscan-title-error" role="heading" aria-live="polite" class="title">{{ 'hardwareScan.scanFinishedHeader.titleError' | translate:{'numberTestsFailed':numberTestsFailed} }}</h2>  <!-- One or more failures -->
			</ng-template>
		</div>
	</ng-template>
	<ng-template #scanFinishedFinalResultCode let-finalResultCodeTitle="finalResultCodeTitle" let-finalResultCodeValue="finalResultCodeValue">
		<div class="row final-result-code">
			<p class="result-code-container">
				<span role="text" class="result-code-value-text">{{ finalResultCodeTitle }} </span>
				<span role="text" id="hwscan-final-result-code-value" class="result-code-complete-text">{{ finalResultCodeValue }}</span>
			</p>
			<div class="result-code-question-mark">
				<vtr-ui-question-mark-button
					*ngIf="numberTestsFailed === 0 && isFinalResultCodeValid(finalResultCodeValue)"
					[componentId]="'hwscan-final-result-code'"
					[ariaLabel]="'final-result-code'"
					[tooltipReference]="tooltipFinalResultCode"
					class="question-mark-container"
				></vtr-ui-question-mark-button>
			</div>
		</div>
	</ng-template>
</div>
